import React, { useMemo } from 'react';
import { Rule } from 'antd/lib/form';
import { useTranslation } from 'react-i18next';
import FormInput from 'components/Input/FormInput';

interface IProps {
	onChange: (value: string) => void;
	setId: string;
}

export const RecipientBankCity: React.FC<IProps> = React.memo(({ onChange, setId }) => {
	const { t } = useTranslation('error');
	const validationRules = useMemo<Rule[]>(() => [{ required: true, message: t('enterRecipientBankCity') }], [t]);

	return (
		<FormInput
			testId="RecipientBankCity"
			name={`recipientBankCity-${setId}`}
			label="recipientBankCityLabel"
			onChange={onChange}
			validationRules={validationRules}
			maxLength={50}
		/>
	);
});
